import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineNotice, formatCount } from '@wit-support/ui';
import { CircleAlert, Info, TriangleAlert } from 'lucide-react';
import { groupIssues, issueMessageText } from '../issues.js';
/** Сколько запусков перечислять поимённо; больше — «в 8 запусках». */
const MAX_NAMED_LAUNCHES = 3;
function where(g, p) {
    const i = g.issue;
    const parts = [];
    let title;
    if (i.fieldKey != null)
        parts.push(p.labelOf?.(i.fieldKey) ?? i.fieldKey);
    const names = g.launchIndexes.map((n) => p.launchLabel?.(n) ?? `запуск ${n + 1}`);
    if (names.length > 0 && names.length <= MAX_NAMED_LAUNCHES)
        parts.push(names.join(', '));
    else if (names.length > MAX_NAMED_LAUNCHES) {
        parts.push(`в ${formatCount(names.length, ['запуске', 'запусках', 'запусках'])}`);
        title = names.join('\n');
    }
    if (i.itemIndex != null)
        parts.push(`креатив ${i.itemIndex + 1}`);
    return title != null ? { text: parts.join(' · '), title } : { text: parts.join(' · ') };
}
const KIND_VIEW = {
    error: {
        variant: 'danger',
        icon: CircleAlert,
        title: 'Ошибки — создание невозможно',
        testId: 'issues-errors',
    },
    warning: {
        variant: 'warning',
        icon: TriangleAlert,
        title: 'Предупреждения',
        testId: 'issues-warnings',
    },
    info: { variant: 'muted', icon: Info, title: 'К сведению', testId: 'issues-info' },
};
/**
 * Ошибки (красные — создание заблокировано), предупреждения (жёлтые) и
 * нейтральные замечания `info` («Страны не исключаются» — не мешают и не
 * предупреждают) проверки пачки. Сообщения — по-русски из реестра auto-ads. Одинаковые
 * замечания разных запусков сведены в одно со списком запусков.
 */
export function IssuesList(props) {
    const grouped = groupIssues(props.issues);
    const errors = grouped.filter((g) => g.issue.severity === 'error');
    const warnings = grouped.filter((g) => g.issue.severity === 'warning');
    const infos = grouped.filter((g) => g.issue.severity === 'info');
    if (errors.length === 0 && warnings.length === 0 && infos.length === 0)
        return null;
    const render = (list, kind) => (_jsx(InlineNotice, { variant: KIND_VIEW[kind].variant, bordered: true, icon: KIND_VIEW[kind].icon, as: "div", "data-testid": KIND_VIEW[kind].testId, children: _jsxs("div", { className: "flex flex-col gap-1", children: [_jsx("span", { className: "font-medium", children: KIND_VIEW[kind].title }), _jsx("ul", { className: "flex list-disc flex-col gap-0.5 pl-4", children: list.map((g, idx) => {
                        const w = where(g, props);
                        return (_jsxs("li", { className: "[overflow-wrap:anywhere]", children: [w.text ? (_jsxs("span", { className: "font-medium", title: w.title, children: [w.text, ":", ' '] })) : null, issueMessageText(g.issue.message)] }, `${g.issue.code}-${idx}`));
                    }) })] }) }));
    return (_jsxs("div", { className: "flex flex-col gap-2", children: [errors.length > 0 ? render(errors, 'error') : null, warnings.length > 0 ? render(warnings, 'warning') : null, infos.length > 0 ? render(infos, 'info') : null] }));
}
//# sourceMappingURL=issues-list.js.map